var m;

export class DiceObject {
	constructor(num, mgr){
		m = mgr;
		this.diceSprite = null;
		this.diceImage = null;
		this.diceContainer = null;

		this.diceNum = num;
		this.defaultHomePosition = {x:0, y:0};
		this.lastPosition = {x:0, y:0};
		this.homePosition = {x:0, y:0};
		this.frameNum = -1;
		this.currentFace = 0;
		this.locked = false;
		this.lockedSortOrder = 0;
		this.tinyDeltaX = 0;
		this.tinyDeltaY = 0;
		this.highlight = null;
		this.soundsPlayed = 0;
		this.highlightOffset = 4;
	}

	addFlair = (animType, theme) => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(0,this.highlightOffset, 'flair');
		// if(theme && (theme === 'volcano' || theme === 'royal')) {
		// 	this.highlight.setTint(0x808080);
		// 	this.highlight.setBlendMode('ADD');
		// }
		this.diceContainer.add(this.highlight);
		this.highlight.setScale(2*m.diceResRatio);//m.highlightScale);
		// this.highlight.setFrame(1);
		this.highlight.anims.play(animType, true);
	}

	addSelectPulse = () => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(this.diceSprite.x, this.diceSprite.y+this.highlightOffset, 'flair');
		this.highlight.setScale(m.highlightScale * 1.06);
		this.highlight.setFrame(26);
		this.highlight.setAlpha(0.50);
		// this.highlight.anims.play(animType, true);
		var tween = m.scene.tweens.add({
			targets     : [ this.highlight ],
			scaleX: m.highlightScale * 1.5,
			scaleY: m.highlightScale * 1.5,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 350,
			repeat      : -1,
			yoyo: true
		});
		m.scoreCardTweens.push(tween);
	}
	addSelectPulseYellowDot = () => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(this.diceSprite.x, this.diceSprite.y+this.highlightOffset, 'flairYellowDot');
		this.highlight.setScale(m.highlightScale * 1.06);
		this.highlight.setFrame(26);
		this.highlight.setAlpha(0.50);
		// this.highlight.anims.play(animType, true);
		var tween = m.scene.tweens.add({
			targets     : [ this.highlight ],
			scaleX: m.highlightScale * 1.5,
			scaleY: m.highlightScale * 1.5,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 350,
			repeat      : -1,
			yoyo: true
		});
		m.scoreCardTweens.push(tween);
	}

	removeFlair = () => {
		if(this.highlight != null)
			this.highlight.destroy();
		this.highlight = null;
	}

	darken = () => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(this.diceSprite.x-1, this.diceSprite.y-1, 'flair');
		this.highlight.setScale(m.highlightScale*1.01);
		this.highlight.setAlpha(0.4);
	}
};
